import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAnexoDoc, getConsentimientoUsuario, getDDJJ } from '../../actions/index'
import 'reactjs-popup/dist/index.css';
import { useParams } from "react-router"
import { PDFViewer } from '@react-pdf/renderer';
import AnexoPDF from '../ReactPDF/AnexoPDF'

const AdminANEXO = () => {

  const token = localStorage.getItem('token')
  const {userId} = useParams()

  const ddjj = useSelector(state => state.ddjj)
  const anexoDoc = useSelector(state => state.anexoDoc)
  const consentimiento = useSelector(state => state.consentimiento)


  const dispatch = useDispatch()

  useEffect(()=>{ 
    dispatch(getAnexoDoc(userId, token))
    dispatch(getDDJJ(userId, token))
    dispatch(getConsentimientoUsuario(userId, token))
    obtenerMes()
  }, [dispatch, token, userId])

  const meses={
    1:"Enero",
    2:"Febrero",
    3:"Marzo",
    4:"Abril",
    5:"Mayo",
    6:"Junio",
    7:"Julio",
    8:"Agosto",
    9:"Septiembre",
    10:"Octubre",
    11:"Noviembre",
    12:"Diciembre"
  }
  useEffect(() => {
    obtenerMes()
  }, [anexoDoc]);
  
  const obtenerMes=()=>{
    for(var key in meses){
      if(Number(anexoDoc.fechaDelDia?.slice(5,7))===Number(key)){
        anexoDoc.mes=meses[key]
      }
    }
  }


  return (
    <div>
      <PDFViewer style={{ width: '100%', height: '100vh'}}>
        <AnexoPDF props={[anexoDoc,consentimiento]} ddjj={ddjj} />
      </PDFViewer>
    </div>

  )
}

export default AdminANEXO